import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Icon from 'components/common/Icon/Icon'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Button from 'components/common/Button/Button'
import Media from 'components/common/Media'
import { VerticalSeparator } from 'components/common/Separator/Separator'

const CurrentTireSize = ({
  activeVehicle: {
    rearTireSize,
    frontTireSize
  },
  addRearTireSizeHandler = () => {},
  editTireSizeHandler = () => {},
  removeRearTireSizeHandler = () => {}
}) =>
  <>
    <CurrentTiresSizesWrapper>
      <Icon asset="check-circle" width={ 12 } height={ 12 } />
      <HelperText>Current Search:</HelperText>
    </CurrentTiresSizesWrapper>
    <TireSizesWrapper>
      { !rearTireSize &&
        <div>
          <SingleTireSize>
            <StaticText>Tire size: </StaticText>
            <TireSizeValue>{ frontTireSize }</TireSizeValue>
          </SingleTireSize>
        </div>
      }
      { rearTireSize &&
        <div>
          <RearWrapper>
            <div>
              <StaticText>Front Tires: </StaticText>
              <TireSizeValue>{ frontTireSize }</TireSizeValue>
            </div>
            <VerticalSeparator margin="0 10px" height="30px" />
            <div>
              <StaticText>Rear Tires: </StaticText>
              <TireSizeValue>{ rearTireSize }</TireSizeValue>
            </div>
          </RearWrapper>
        </div>
      }
      <EditTireSizeButton aria-label="edit tire size" link onClick={ editTireSizeHandler }>
        edit
        <EditIcon asset="edit-blue" width={ 16 } height={ 16 } />
      </EditTireSizeButton>
    </TireSizesWrapper>
    {
      !rearTireSize
        ? (
          <AddRemoveRearSizesWrapper aria-label="Add a Different Rear Tire Size" onClick={ addRearTireSizeHandler }>
            <CircleIcon>&#43;</CircleIcon>
            <AddRemoveRearTireSizeText>
              Add a Different Rear Tire Size
            </AddRemoveRearTireSizeText>
          </AddRemoveRearSizesWrapper>
        ) : (
          <AddRemoveRearSizesWrapper aria-label="Remove a Different Rear Tire Size" onClick={ removeRearTireSizeHandler }>
            <RemoveCircleIcon>&#8211;</RemoveCircleIcon>
            <AddRemoveRearTireSizeText>
              Remove a Different Rear Tire Size
            </AddRemoveRearTireSizeText>
          </AddRemoveRearSizesWrapper>
        )
    }
  </>

export default CurrentTireSize

CurrentTireSize.propTypes = {
  activeVehicle: PropTypes.shape({
    rearTireSize: PropTypes.string,
    frontTireSize: PropTypes.string
  }),
  addRearTireSizeHandler: PropTypes.func,
  editTireSizeHandler: PropTypes.func,
  removeRearTireSizeHandler: PropTypes.func
}

const HelperWrapper = styled.div`
  display: flex;
  align-items: center;
`

const CurrentTiresSizesWrapper = styled(HelperWrapper)`
  margin-bottom: 15px;
  ${Media.mobile`
    justify-content: center;
  `}

  @media (max-width: 450px) {
    justify-content: start;
  }
`

const AddRemoveRearSizesWrapper = styled.button`
  margin-bottom: 25px;
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  background: transparent;
  border: none;
  color: #1262ac;
`

const HelperText = styled.div`
  ${Mixin.font.GothamBook(16, 400, 26)};
  color: ${Theme.colors.black_new};
  margin-left: 3px;
`

const TireSizesWrapper = styled.div`
  margin: 15px 0;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  ${Media.mobile`
    justify-content: center;
  `}

  @media (max-width: 450px) {
    justify-content: space-between;
  }
`

const SingleTireSize = styled.div`
  display: flex;
  align-items: center;
`

const StaticText = styled.div`
  ${Mixin.font.GothamBook(14, 400, 20)};
  color: ${Theme.colors.medium_grey};
  margin-right: 10px;
`

const TireSizeValue = styled.div`
  ${Mixin.font.GothamBold(18, 700, 18)};
  color: ${Theme.colors.black_new};
`

const CircleIcon = styled.div`
  width: 14px;
  height: 14px;
  color: #1262ac;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #1262ac;
  border-radius: 50%;
`

const RemoveCircleIcon = styled(CircleIcon)`
  padding-bottom: 3px;
`

const AddRemoveRearTireSizeText = styled.div`
  padding: 0 !important;
  ${Mixin.font.GothamBold()}
  margin-left: 5px;
  cursor: pointer;

  &:hover {
    text-decoration: none !important;
  }
`

const EditTireSizeButton = styled(Button)`
  display: flex;
  align-items: end;
  cursor: pointer;
  padding: 0 !important;

  &:hover {
    text-decoration: none !important;
  }

  ${Media.mobile`
    margin-left: 10px;
  `}

  @media (max-width: 450px) {
    margin-left: 0;
  }
`

const EditIcon = styled(Icon)`
  margin-left: 5px;
`

const RearWrapper = styled.div`
  display: flex;
  align-items: center;
`
